import { SdkContext } from '../internal'

/** F-188: where the connection stands (see the docs' "Os estados da conexão"). */
export type EmailProviderStatus = 'pending' | 'active' | 'error' | 'paused_by_plan'

/** The community's Resend account as owner and admin see it: never the key or the secret, only their last 4. */
export interface EmailProvider {
  configured: boolean
  /** The plan includes it (Business and above, or released by the SuperAdmin); false: save and verify answer 403. */
  planAllowed: boolean
  provider?: string
  status: EmailProviderStatus | null
  fromEmail?: string
  fromName?: string
  replyTo?: string | null
  apiKeyMasked?: string
  apiKeyLast4?: string
  webhookSecretLast4?: string | null
  /** The address to register as a webhook in the community's Resend account. */
  webhookUrl?: string
  lastError?: string | null
  lastEventAt?: string | null
  verifiedAt?: string | null
  verifyRequestedAt?: string | null
  planLostAt?: string | null
  /** With `paused_by_plan`: when the key and the secret are wiped. */
  retentionEndsAt?: string | null
  dataNotice: { version: string; accepted: boolean; acceptedAt: string | null }
}

export interface EmailProviderInput {
  apiKey?: string
  webhookSecret?: string
  fromEmail?: string
  fromName?: string
  replyTo?: string | null
  acceptDataNotice?: boolean
}

/**
 * F-188: `/api/email-provider`, owner and admin of the `X-CommunityId`. `GET` answers on any plan
 * (`planAllowed`); saving and verifying below Business are 403 `emailProvider.planRequired`.
 */
export class EmailProviderResource {
  constructor(private ctx: SdkContext) {}

  async get(): Promise<EmailProvider> {
    return this.ctx.call({ httpMethod: 'GET', path: '/email-provider' })
  }

  /** Connects or changes it; a new key or sender address sends the status back to `pending`. */
  async save(body: EmailProviderInput): Promise<EmailProvider> {
    return this.ctx.call({ httpMethod: 'PUT', path: '/email-provider', hasBody: true }, { body })
  }

  /** Wipes the key and the secret; e-mails leave through Memberfy again. */
  async disconnect(): Promise<{ disconnected: boolean }> {
    return this.ctx.call({ httpMethod: 'DELETE', path: '/email-provider' })
  }

  /** Sends a test from the sender to who clicked; the connection turns `active` when the delivery event arrives. */
  async verify(): Promise<EmailProvider> {
    return this.ctx.call({ httpMethod: 'POST', path: '/email-provider/verify', hasBody: true }, { body: {} })
  }
}
